import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';

const EstudanteCard = ({ estudante }) => {
  return (
    <Card>
      <CardContent>
        <Typography variant="h5" component="div">
          {estudante.nome}
        </Typography>
        <Typography color="text.secondary">
          Email: {estudante.email}
        </Typography>
        <Typography variant="body2">
          Data de Nascimento: {new Date(estudante.dataNascimento).toLocaleDateString()}
        </Typography>
        <Button 
          component={Link} 
          to={`/estudantes/${estudante.id}`} 
          variant="contained" 
          color="primary" 
          sx={{ mt: 2 }}
        >
          Ver Detalhes
        </Button>
      </CardContent>
    </Card>
  );
};

EstudanteCard.propTypes = {
  estudante: PropTypes.shape({
    nome: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    dataNascimento: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
  }).isRequired,
};

export default EstudanteCard;
